export function Table({ children, className = '', fixed = false }) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className={`w-full text-sm ${fixed ? 'table-fixed' : ''}`}>{children}</table>
    </div>
  );
}

export function Thead({ children }) {
  return (
    <thead className="border-b border-border">
      {children}
    </thead>
  );
}

export function Th({ children, className = '', align = 'left' }) {
  return (
    <th className={`py-2.5 px-3 text-[11px] font-medium uppercase tracking-wider text-text-secondary text-${align} ${className}`}>
      {children}
    </th>
  );
}

import { forwardRef } from 'react';

export const Td = forwardRef(function Td({ children, className = '', align = 'left', ...props }, ref) {
  return (
    <td ref={ref} className={`py-2.5 px-3 text-${align} ${className}`} {...props}>
      {children}
    </td>
  );
});

export function Tr({ children, className = '' }) {
  return (
    <tr className={`even:bg-bg-tertiary/20 hover:bg-bg-tertiary/40 transition-colors ${className}`}>
      {children}
    </tr>
  );
}
